'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconRemoveCircle = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12 23.5A11.5 11.5 0 1 0 .5 12 11.513 11.513 0 0 0 12 23.5zM7.05 8.465a1 1 0 1 1 1.414-1.414l3.359 3.359a.25.25 0 0 0 .353 0l3.359-3.359a1 1 0 1 1 1.414 1.414l-3.359 3.359a.25.25 0 0 0 0 .353l3.359 3.359a1 1 0 1 1-1.414 1.414l-3.359-3.359a.25.25 0 0 0-.353 0L8.464 16.95a1 1 0 0 1-1.414-1.414l3.359-3.359a.25.25 0 0 0 0-.353z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M11.999 23.5C5.658 23.5.499 18.341.499 12S5.658.5 11.999.5s11.5 5.159 11.5 11.5-5.159 11.5-11.5 11.5zm0-22c-5.79 0-10.5 4.71-10.5 10.5s4.71 10.5 10.5 10.5 10.5-4.71 10.5-10.5-4.71-10.5-10.5-10.5z' }),
    _react2.default.createElement('path', { d: 'M16.241 16.743a.5.5 0 0 1-.354-.146l-3.889-3.889-3.889 3.889a.5.5 0 1 1-.708-.707L11.292 12l-3.89-3.888a.5.5 0 0 1 .354-.853.5.5 0 0 1 .354.146l3.889 3.889 3.889-3.889a.498.498 0 0 1 .706 0 .5.5 0 0 1 0 .707L12.706 12l3.889 3.889a.5.5 0 0 1-.354.854z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M15.182 15.931a.743.743 0 0 1-.53-.22L12 13.06l-2.652 2.651a.744.744 0 0 1-.53.22.75.75 0 0 1-.531-1.28L10.939 12 8.288 9.348a.743.743 0 0 1-.22-.53c0-.2.078-.389.22-.53.141-.142.33-.22.53-.22s.389.078.53.22L12 10.939l2.652-2.651a.744.744 0 0 1 1.06 0 .744.744 0 0 1 0 1.06L13.061 12l2.652 2.651a.75.75 0 1 1-.531 1.28z' }),
    _react2.default.createElement('path', { d: 'M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-22.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconRemoveCircle.displayName = 'IconRemoveCircle';
exports.default = IconRemoveCircle;